<template>
  <div>
    <a-row class="pbz-font d-flex align-items-center">
      <a-col :span="1" class="d-flex justify-content-start">
        <div style="cursor: pointer" @click.prevent="back()">
          <ArrowIcon
            class="ant-dropdown-link"
            style="color: #0559cb; height: 100px; width: 25px"
            :rotate="'rotate(270)'"
            @click="(e) => e.preventDefault()"
          />
        </div>
      </a-col>
      <a-col
        class="d-flex justify-content-center align-items-center"
        :span="5"
        style="border-left: 1px solid rgb(204, 204, 204)"
      >
        <div style="color: #0559cb; margin-right: 5px">
          {{ $t('fulfillment.order_list') }} >
        </div>
        {{ $t('fulfillment.print_label') }}
      </a-col>
    </a-row>
    <a-row>
      <div
        class="pbz-font subtitle-sm-medium d-flex"
        style="margin: 20px 210px"
      >
        {{ $t('fulfillment.setting_label') }}
      </div>
      <a-col :span="14" class="d-flex justify-content-end">
        <div class="label-shipment">
          <div class="label-shipment-content">
            <div class="unboxing-warning" style="margin-bottom: 10px">
              <img src="@/assets/images/unboxing-warning.webp" width="100%" />
            </div>
            <div class="label-shipment-content-border">
              <div class="my-2">
                <a-row class="d-flex">
                  <a-col
                    :span="6"
                    style="margin: 0 10px; font-weight: bold; text-align: left; font-size: 12px;"
                  >
                    <div class="d-flex">
                      {{ $t('fulfillment.logistic') }}
                    </div>
                  </a-col>
                  <a-col
                    :span="18"
                    style="margin: 0 10px; font-weight: bold; text-align: left; font-size: 12px;"
                  >
                    <div class="d-flex">
                      : {{
                        [
                          shipping?.courier, shipping?.service_name
                        ].filter((item) => item).join(' - ')
                      }}
                    </div>
                  </a-col>
                </a-row>
                <a-row class="d-flex">
                  <a-col
                    :span="6"
                    style="margin: 0 10px; font-weight: bold; text-align: left; font-size: 12px;"
                  >
                    <div class="d-flex">
                      {{ $t('fulfillment.shippingCost') }}
                    </div>
                  </a-col>
                  <a-col
                    :span="18"
                    style="margin: 0 10px; font-weight: bold; text-align: left; font-size: 12px;"
                  >
                    <div class="d-flex">
                      : {{ shipping.shipping_cost?.currency }} {{ Number(shipping.shipping_cost?.value).toLocaleString('id-ID') }}
                    </div>
                  </a-col>
                </a-row>
                <a-row v-if="shipping.insurance_cost?.value > 0" class="d-flex">
                  <a-col
                    :span="6"
                    style="margin: 0 10px; font-weight: bold; text-align: left; font-size: 12px;"
                  >
                    <div class="d-flex">
                      {{ $t('fulfillment.insuranceCost') }}
                    </div>
                  </a-col>
                  <a-col
                    :span="18"
                    style="margin: 0 10px; font-weight: bold; text-align: left; font-size: 12px;"
                  >
                    <div class="d-flex">
                      : {{ shipping.insurance_cost?.currency }} {{ Number(shipping.insurance_cost?.value).toLocaleString('id-ID') }}
                    </div>
                  </a-col>
                </a-row>
              </div>
              <template v-if="isAwbExist">
                <div class="d-flex justify-items-center text-center justify-content-center w-100">
                  <div class="d-flex flex-column w-100 mx-2 mb-1">
                    <div class="bold awb-tag-name py-2" style="margin-top: 0px">
                      <span style="font-weight: normal; letter-spacing: 0px; padding-right: 10px;">AWB:</span>{{ shipping.awb }}
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-items-center text-center justify-content-center mb-3 w-100">
                  <VueBarcode
                    v-model="shipping.awb"
                    :options="barcode"
                    style="max-width: 500px; max-height: 80px;"
                  />
                </div>
              </template>
              <div
                class="d-flex"
                style="
                  padding-top: 10px;
                  font-size: 12px;
                  text-align: left;
                  border-top: 1px dotted #cccccc;
                "
              >
                <div :style="{ width: firstRecipientSortCode ? '80%' : '100%' }">
                  <a-row class="d-flex">
                    <a-col :span="24" style="margin: 0px 10px; text-align: left; font-size: 12px; width: fit-content;">
                      <div class="d-flex" style="font-weight: bold">
                        {{ $t('fulfillment.sender') }}: 
                        <span class="ml-2">
                          {{ sender?.name || shipment?.name || salesData?.business?.business_title || '' }}
                        </span>
                      </div>
                      <div class="d-flex">
                        {{ sender?.address || shipment?.address || '' }}
                      </div>
                      <div class="d-flex">
                        {{ sender?.phone || shipment?.phone || '' }}
                      </div>
                    </a-col>
                  </a-row>
                  <a-row class="d-flex">
                    <a-col :span="24" style="margin: 10px 10px 0; text-align: left; font-size: 12px; width: fit-content;">
                      <div class="d-flex" style="font-weight: bold">
                        {{ $t('fulfillment.recipient') }}
                      </div>
                      <div class="d-flex">
                        {{ destination?.name || '-' }}
                      </div>
                      <div class="d-flex">
                        <template v-if="destination.address">
                          {{ destination.address?.line1 }}
                          {{ destination.address?.line2 }},
                          {{ destination.address?.sub_district }},
                          {{ destination.address?.district }},
                          {{ destination.address?.province }},
                          {{ destination.address?.postal_code }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </div>
                      <div class="d-flex">
                        {{ destination?.phone || '-' }}
                      </div>
                    </a-col>
                  </a-row>
                </div>
                <div
                  v-if="firstRecipientSortCode"
                  style="width: 20%"
                  class="d-flex flex-column justify-content-between align-items-center px-1 mr-1"
                >
                  <div class="bold awb-tag-name py-1 text-center w-100" style="font-size: 12px;">
                    {{ firstRecipientSortCode }}
                  </div>
                  <div v-if="shippingAttribute?.order_weight" class="text-center w-100" style="font-size: 10px; margin-top: auto;">
                    <div>{{ $t('product.weight') }}:</div>
                    <div><b>{{ shippingAttribute?.order_weight }}</b> gr</div>
                  </div>
                </div>
              </div>
              <div
                v-if="printFulfillmentId"
                style="
                  margin-top: 10px;
                  font-weight: 600;
                  font-size: 14px;
                  text-align: center;
                  border-top: 1px dotted #cccccc;
                "
              >
                <a-row :gutter="16">
                  <a-col :span="24">
                    <div v-if="isExist" style="margin-top: 10px">
                      <VueBarcode
                        v-model="order.order_number"
                        :options="barcode"
                        style="max-width: 500px; max-height: 80px;"
                      />
                    </div>
                    <div v-if="isExist" style="margin-bottom: 15px;">
                      {{ $t('fulfillment.orderNo') }}: {{ order.order_number }}
                    </div>
                  </a-col>
                </a-row>
              </div>
              <div
                style="
                  margin: 10px 0px;
                  padding-top: 10px;
                  font-size: 12px;
                  text-align: left;
                  border-top: 1px dotted #cccccc;
                "
              >
                <a-row class="d-flex">
                  <a-col
                    :span="6"
                    style="margin: 0 10px; font-weight: bold; text-align: left"
                  >
                    <div class="d-flex">
                      {{ $t('fulfillment.orderNo') }}
                    </div>
                  </a-col>
                  <a-col
                    :span="18"
                    style="margin: 0 10px; font-weight: bold; text-align: left"
                  >
                    <div class="d-flex">
                      : {{ order.order_number }}
                    </div>
                  </a-col>
                </a-row>
                <a-row class="d-flex">
                  <a-col
                    :span="6"
                    style="margin: 0 10px; font-weight: bold; text-align: left"
                  >
                    <div class="d-flex">
                      {{ $t('fulfillment.orderDate') }}
                    </div>
                  </a-col>
                  <a-col
                    :span="18"
                    style="margin: 0 10px; font-weight: bold; text-align: left"
                  >
                    <div class="d-flex">
                      : {{ parseISOString(order.order_date) }}
                    </div>
                  </a-col>
                </a-row>
                <a-row v-if="isShowValueOrder" class="d-flex">
                  <a-col
                    :span="6"
                    style="margin: 0 10px; font-weight: bold; text-align: left"
                  >
                    <div class="d-flex">
                      {{ $t('fulfillment.sub_total_order') }}
                    </div>
                  </a-col>
                  <a-col
                    :span="18"
                    style="margin: 0 10px; font-weight: bold; text-align: left"
                  >
                    <div class="d-flex">
                      : {{ salesData?.sub_total | currency }}
                    </div>
                  </a-col>
                </a-row>
              </div>
              <div
                style="
                  margin: 10px 0px;
                  padding-top: 10px;
                  font-size: 12px;
                  text-align: left;
                  border-top: 1px dotted #cccccc;
                "
              >
                <a-row class="d-flex">
                  <a-col
                    :span="24"
                    style="margin: 0 10px; text-align: left"
                  >
                    <div class="d-flex">
                      {{ $t('fulfillment.note') }} :
                    </div>
                  </a-col>
                </a-row>
              </div>
              <div
                v-if="printDetailProduk"
                style="
                  margin: 10px 0px;
                  font-size: 12px;
                  text-align: left;
                  border-top: 1px solid #cccccc;
                "
              >
                <a-row class="d-flex" style="width: 100%">
                  <a-col :span="20" style="margin: 10px 10px">
                    <div>{{ $t('fulfillment.product') }}</div>
                  </a-col>
                  <a-col :span="2" style="margin: 10px 0">
                    <div>{{ $t('fulfillment.quantity') }}</div>
                  </a-col>
                </a-row>
                <a-row v-for="(item, index) in product" :key="index" class="d-flex" style="width: auto;">
                  <a-col :span="20" style="margin: 1px 10px">
                    <div>{{ item.catalog_title }}</div>
                  </a-col>
                  <a-col :span="2" style="margin: 1px 0">
                    <div style="text-align: center">
                      <b>{{ item.quantity }}</b> {{ item.uom }}
                    </div>
                  </a-col>
                </a-row>
              </div>
            </div>
          </div>
        </div>
      </a-col>

      <a-col :span="10" class="d-flex">
        <div class="box-print">
          <a-row class="pbz-font">
            <a-col
              class="d-flex"
              style="margin: 30px 30px"
            >
              {{ $t('fulfillment.paper_size') }}
            </a-col>
            <a-col
              class="d-flex"
              style="
                padding-bottom: 30px;
                margin: 30px 30px;
                border-bottom: 1px solid #cccccc;
              "
            >
              <a-radio-group v-model="size" :default-value="'a4'" @change="setPageSize(size)">
                <a-radio :value="'a4'">
                  A4
                </a-radio>
                <a-radio :value="'148mm 210mm'">
                  A5
                </a-radio>
                <a-radio :value="'105mm 148mm'">
                  A6
                </a-radio>
              </a-radio-group>
            </a-col>
            <a-col class="d-flex" style="margin: 30px 30px">
              <a-checkbox :default-checked="printDetailProduk" @change="setDetailProduk">
                {{ $t('fulfillment.print_details') }}
              </a-checkbox>
            </a-col>
            <a-col class="d-flex" style="margin: 30px 30px">
              <a-checkbox :default-checked="true" @change="setPrintFulfillmentId">
                {{ $t('fulfillment.printWithShippingId') }}
              </a-checkbox>
            </a-col>
          </a-row>
          <a-row class="pbz-font d-flex justify-content-center">
            <a-col :span="22">
              <button class="accept-button-modal" onClick="window.print()">
                {{ $t('fulfillment.print_label') }}
              </button>
            </a-col>
          </a-row>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { getSales } from '@/api/sales'
import { getFulfillmentDetail, getFulfillmentDetailByOrder } from '@/api/fulfillment'
import { getWarehouseById } from '@/api/warehouse'
import { getStock } from '@/api/inventory'
import ArrowIcon from '@/components/Icons/Arrow.vue'
import VueBarcode from '@chenfengyuan/vue-barcode'
import getQueryParam from '@/utils/getQueryParam'
import { getBusinessMetaData } from '@/api/business'
import { getShippingDetailWithAttribute } from '@/api/shipping'

export default {
  name: 'FulfillmentLabel',
  components: {
    ArrowIcon,
    VueBarcode,
  },
  mixins: [getQueryParam],
  data: function () {
    return {
      tokopedia: require('@/assets/integration/channel/tokopedia.png'),
      sicepat: require('@/assets/courier/sicepat.png'),
      anteraja: require('@/assets/courier/anteraja.png'),
      jne: require('@/assets/courier/jne.png'),
      sap: require('@/assets/courier/sap.png'),
      paxel: require('@/assets/courier/paxel.png'),
      detail: [],
      product: [],
      fulfillmentDataRAW: {},
      destination: [],
      shipping: {},
      size: '',
      printDetailProduk: this.$route.params.label_product,
      printFulfillmentId: true,
      shipment: {},
      order: {},
      sender: {},
      salesData: null,
      showValueOnShippingLabel: [],
      activeFulfillmentId: '',
      shippingAttribute: {},
    }
  },
  computed: {
    barcode() {
      return {
        height: 80,
        width: 1.5,
        displayValue: false,
      }
    },
    barcodeSmall() {
      return {
        height: 40,
        width: 1.5,
        displayValue: false,
      }
    },
    topBarcode() {
      return this.shipping.awb !== null ? this.shipping.awb : this.shipping.booking_no
    },
    isExist() {
      return this.detail[0] && this.detail[0].fulfillment_number
    },
    isAwbExist() {
      return Boolean(this.shipping?.awb)
    },
    isShowValueOrder() {
      const detailOrder = this.fulfillmentDataRAW?.order
      return Boolean(this.showValueOnShippingLabel.includes(detailOrder?.channel?.id))
    },
    firstRecipientSortCode() {
      return (
        this.shippingAttribute?.recipient_sort_code?.first_recipient_sort_code ||
        this.shippingAttribute?.first_recipient_sort_code ||
        ''
      )
    },
  },
  mounted() {
    this.fetchDetailFulfillmentBasedOrderId()
  },
  methods: {
    parseISOString(dateTime) {
      if (!dateTime) return ''
      return typeof dateTime === 'number'
        ? this.$moment.unix(dateTime).format('DD MMMM YYYY')
        : this.$moment(dateTime).format('DD MMMM YYYY')
    },
    getCourierLogo(param) {
      switch (param.toLowerCase()) {
        case 'sicepat' :
          return this.sicepat
        case 'anteraja' :
          return this.anteraja
        case 'jne' :
          return this.jne
        case 'sap' :
          return this.sap
        case 'paxel' :
          return this.paxel
      }
    },
    setDetailProduk(e) {
      this.printDetailProduk = e.target.checked
    },
    setPrintFulfillmentId(e) {
      this.printFulfillmentId = e.target.checked
    },
    setPageSize(value) {
      const style = document.createElement('style')
      style.innerHTML = `@page {size: ${value}}`
      document.head.appendChild(style)
    },
    async fetchDetailFulfillmentBasedOrderId() {
      const { order_id, business_id } = this.$route.query
      try {
        const { data: { data: orderData } } = await getFulfillmentDetailByOrder({ business_id, order_id })
        const sortedFulfillments = [...orderData.fulfillments].sort((a, b) => a.created_at - b.created_at)
        this.activeFulfillmentId = sortedFulfillments[0].id

        const { data: { data: response } } = await getFulfillmentDetail({
          url: 'fulfillment',
          fulfillment_id: this.activeFulfillmentId,
        })
        this.fulfillmentDataRAW = response
        this.detail = response.fulfillments
        this.order = response.order
        this.getDataDetail()
        this.fetchBusinessMetaData()
        this.fetchWarehouseId(response.warehouse_id)
        const orderId = response.order?.id || response.order_id || response.order?.id_uuid
        const businessId = response.business_id || response.order?.business_id
        this.fetchShippingAttribute(orderId, businessId)
      } catch (err) {
        console.error(err)
      }
    },
    fetchBusinessMetaData() {
      getBusinessMetaData({
        business_id: this.fulfillmentDataRAW.business_id,
      })
      .then(({ data: response }) => {
        let findMetaValue
        response.forEach((item) => {
          if (item.meta_name === 'show_value_on_shipping_label') {
            findMetaValue = JSON.parse(item.meta_value)
          }
        })
        if (findMetaValue) {
          this.showValueOnShippingLabel = findMetaValue.channel_id
        } else {
          this.showValueOnShippingLabel = []
        }
      })
      .catch((err) => console.error(err))
    },
    fetchShippingAttribute(orderId, businessId) {
      if (!orderId) return
      getShippingDetailWithAttribute({
        order_id: orderId,
        business_id: businessId,
      })
      .then(({ data: { data: response } }) => {
        if (response?.attributes) {
          try {
            let parsed = response.attributes
            if (typeof parsed === 'string') {
              parsed = parsed.replace(/[\u201C\u201D]/g, '"').replace(/[\u2018\u2019]/g, "'")
              parsed = JSON.parse(parsed)
              if (typeof parsed === 'string') {
                parsed = parsed.replace(/[\u201C\u201D]/g, '"').replace(/[\u2018\u2019]/g, "'")
                parsed = JSON.parse(parsed)
              }
            }
            this.shippingAttribute = parsed || {}
          } catch (e) {
            console.error('Error parsing shipping attributes:', e)
            this.shippingAttribute = {}
          }
        } else {
          this.shippingAttribute = {}
        }
      })
      .catch((err) => console.error(err))
    },
    async fetchWarehouseId(warehouseId) {
      await getWarehouseById(warehouseId)
      .then(({ data: { data: response } }) => this.shipment = response)
      .catch((err) => console.error(err))
    },
    getDataDetail() {
      const { query } = this.$route
      const { workspace_id } = query
      const data = this.detail.find((item) => item.id === this.activeFulfillmentId)
      this.product = data.line_items
      this.destination = data.destination
      this.shipping = data.shipping
      this.sender = data.sender

      this.controller = new AbortController()

      const payload = {
        signal: this.controller.signal,
        params: {
          business_id: this.fulfillmentDataRAW.business_id,
          workspace_id,
          page: 1,
          limit: 20,
          sort_mode: 'DESC',
          q: this.order.order_number,
        },
      }

      getSales(payload)
        .then(({ data: response }) => {
          if (response.total_row > 0) {
            const findSalesByOrderNumber = response.data.find((item) => item.order_number === this.order.order_number)
            if (findSalesByOrderNumber) {
              this.salesData = findSalesByOrderNumber
            } else {
              this.salesData = null
            }
          } else {
            this.salesData = null
          }
        })
        .catch((err) => console.error(err))

    },
    back() {
      this.$router.push({
        name: this.$route.params.id === undefined ? 'fulfillment.index' : 'channel-fulfillment',
        query: {
          ...this.getQueryParam(this.$route.query),
        },
      })
    },
  },
}
</script>

<style  lang="scss">

.label-shipment {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;

  position: absolute;
  min-width: 599px;
  width: auto;
  height: auto;

  /* Global Color/White */

  background: #ffffff;
  /* Global Color/Grey/Grey-100 */

  border: 1px solid #cccccc;
  box-sizing: border-box;
  border-radius: 8px;
  .label-shipment-content {
    min-width: 501px;
    max-width: 525px;
    width: auto;
    height: auto;
    box-sizing: border-box;
  }
  .label-shipment-content-border {
    border: 1px solid #000000;
  }
}
.box-print {
  position: absolute;
  width: 345px;
  height: auto;
  margin-left: 40px;

  /* Global Color/White */

  background: #ffffff;
  /* Global Color/Grey/Grey-100 */

  border: 1px solid #cccccc;
  box-sizing: border-box;
  border-radius: 8px;

  .ant-radio-wrapper {
    color: #0559CB !important;
  }
}

.accept-button-modal {
  margin: 10px 0px;
  border: 1px solid #0559cb;
  background: #0559cb;
  color: #ffffff;
  width: 100%;
  padding: 0.75rem;
  border-radius: 5px;
  cursor: pointer;
}
.awb-tag-name {
  border: 1px solid #000000;
  width: 100%;
  letter-spacing: 2px;
  font-weight: bold;
  font-size: 14px;
}
@media print {
  body * {
    visibility: hidden;
  }
  .label-shipment * {
    visibility: visible;
  }
  .label-shipment {
    position: fixed;
    margin: 0;
    left: 0;
    top: 0;
  }
}
</style>
